module.exports = __webpack_public_path__ + "static/media/startbild_sw_mit_flasche.091f3970.jpg";